"use client";

import { usePathname, useRouter } from "next/navigation";
import * as R from "ramda";

import { toast } from "@jasperlabs/ui";

import { NOTIFICATIONS_BASE_ROUTE } from "@/constants/notifications";
import { useMutationOnSuccess } from "@/api";
import { track } from "@/lib/posthog";

import useNotificationsQuery from "./useNotificationsQuery";
import {
	pathForNotification,
	contentForNotification,
} from "./notificationEnhancers";

const titleForPathname = (pathname, notifications) => {
	const current = R.find(
		R.compose(R.equals(pathname), pathForNotification),
		notifications ?? [],
	);
	const content = contentForNotification(current);
	return content ? content.title() : null;
};

export const useNotificationsOnComplete = ({
	successMessage = null,
	showSuccessToast = true,
} = {}) => {
	const router = useRouter();
	const pathname = usePathname();
	const [notifications] = useNotificationsQuery();

	return () => {
		const current = R.find(
			R.compose(R.equals(pathname), pathForNotification),
			notifications ?? [],
		);
		track("notification_completed", {
			notification_type: current?.__typename,
		});

		if (showSuccessToast) {
			const title = titleForPathname(pathname, notifications);
			const message =
				successMessage ??
				(title
					? `Notification resolved: ${title}`
					: "Thank you for submitting your information.");
			toast.success(message);
		}
		router.push(NOTIFICATIONS_BASE_ROUTE);
	};
};

const useNotificationsMutationOnSuccess = (mutation) => {
	const onComplete = useNotificationsOnComplete();
	return useMutationOnSuccess(onComplete, mutation);
};

export default useNotificationsMutationOnSuccess;
